export default __webpack_public_path__ + "static/media/jane-churchyard-benefits-2.81e7006f.jpg";